<sd-form checkbox
  class="c__warranty-checkbox"
  [id]="warranty.uuid"
  [labelTitle]="warranty.labelTitle"
  [checked]="warranty.state"
  [nameField]="warranty.nameField"
/>
<div class="c__warranty-wrapper">
  <ul sd-list-block>
    @for (listItem of warranty.list; track listItem) {
      @if ($first || showAll) {
        <li>
          <sd-icon name="icon-check" [size]="iconSizeEnum.small" />{{ listItem }}
        </li>
      }
    }
  </ul>
  <p class="is-body-m is-bold">{{ warranty.price }}</p>
</div>
